/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const SlackIcon = ({size, ...props}) => (
  <svg viewBox="0 0 13 13" fill="currentColor" width={ size || "13" } height={ size || "13" } {...props}>
    <g fill="none" fillRule="nonzero">
      <path d="M2.659 1.3c0 .706-.59 1.277-1.317 1.277S.025 2.006.025 1.3C.025.595.615.024 1.342.024h1.317V1.3zM3.318 1.3c0-.705.59-1.276 1.317-1.276S5.952.595 5.952 1.3v3.192c0 .706-.59 1.277-1.317 1.277-.728 0-1.317-.571-1.317-1.277V1.3z"
        transform="translate(0 7)" fill="#E01E5A" />
      <path d="M4.635 2.577c-.728 0-1.317-.571-1.317-1.277 0-.705.59-1.276 1.317-1.276S5.952.595 5.952 1.3v1.277H4.635zM4.635 3.216c.727 0 1.317.571 1.317 1.276 0 .706-.59 1.277-1.317 1.277H1.342C.615 5.77.025 5.198.025 4.492c0-.705.59-1.276 1.317-1.276h3.293z"
        fill="#36C5F0" />
      <path d="M3.318 4.492c0-.705.59-1.276 1.317-1.276s1.317.571 1.317 1.276c0 .706-.59 1.277-1.317 1.277H3.318V4.492zM2.659 4.492c0 .706-.59 1.277-1.317 1.277S.025 5.198.025 4.492V1.3C.025.595.615.024 1.342.024S2.659.595 2.659 1.3v3.192z"
        transform="translate(7)" fill="#2EB67D" />
      <path d="M1.342 3.216c.727 0 1.317.571 1.317 1.276 0 .706-.59 1.277-1.317 1.277S.025 5.198.025 4.492V3.216h1.317zM1.342 2.577C.615 2.577.025 2.006.025 1.3.025.595.615.024 1.342.024h3.293c.727 0 1.317.571 1.317 1.276 0 .706-.59 1.277-1.317 1.277H1.342z"
        transform="translate(7 7)" fill="#ECB22E" />
    </g>
  </svg>
);
SlackIcon.displayName = 'SlackIcon';
SlackIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
